import { Star } from "lucide-react";

export default function ReviewCard({ review, dataTestId }) {
    return (
        <div
            data-testid={dataTestId}
            className="bg-white rounded-3xl border border-slate-100 premium-shadow p-7 hover-lift"
        >
            <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                    <Star
                        key={i}
                        className={`w-4 h-4 ${
                            i < review.rating ? "fill-yellow-400 text-yellow-400" : "text-slate-200"
                        }`}
                    />
                ))}
            </div>
            <p className="text-slate-700 leading-relaxed">&ldquo;{review.content}&rdquo;</p>
            <div className="mt-6 flex items-center gap-3">
                {review.avatar ? (
                    <img
                        src={review.avatar}
                        alt={review.name}
                        className="h-10 w-10 rounded-full object-cover ring-2 ring-white"
                    />
                ) : (
                    <div className="h-10 w-10 rounded-full bg-slate-100 grid place-items-center font-display font-bold text-slate-600">
                        {review.name?.[0]}
                    </div>
                )}
                <div>
                    <div className="font-semibold text-slate-900 text-sm">{review.name}</div>
                    {review.location && (
                        <div className="text-xs text-slate-500">{review.location}</div>
                    )}
                </div>
            </div>
        </div>
    );
}
